import React from 'react'
import { Box, Container, Paper } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import ClearIcon from '@mui/icons-material/Clear'
import Header from 'src/designSystem/Header/Header'

type Props = {
  title: string | undefined
  iconCategory: string | null | undefined
  summary?: React.ReactNode
  onRemove?: () => void
  removeAriaLabel: string
}

const useStyles = makeStyles((theme) => ({
  previewContainer: {
    padding: theme.spacing(1),
  },
  clearIcon: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(3),
    cursor: 'pointer',
  },
}))

const LinkedItemPreview: React.FunctionComponent<Props> = ({
  title,
  iconCategory,
  summary,
  onRemove,
  removeAriaLabel,
}) => {
  const classes = useStyles()

  return (
    <Container classes={{ root: classes.previewContainer }}>
      <Box display="flex" alignItems="center">
        <Paper variant="outlined">
          <Header title={title} iconCategory={iconCategory} summary={summary} />
        </Paper>
        {onRemove && (
          <ClearIcon aria-label={removeAriaLabel} onClick={onRemove} classes={{ root: classes.clearIcon }} />
        )}
      </Box>
    </Container>
  )
}

export default LinkedItemPreview
